export default "__VITE_ASSET__BX$bqVhl__"